import { ENV } from "../utils";

export class DdPolicyTracker {
  baseApi = ENV.BASE_API;

  async getData(accessToken) {
    const response = await fetch(`${this.baseApi}/dd-tr`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async saveData(accessToken, data) {
    const response = await fetch(`${this.baseApi}/dd-tr`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async uploadFile(accessToken, formData) {
    const response = await fetch(`${this.baseApi}/dd-tr/upload-file`, {
      method: "POST",
      body: formData,
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getFile(accessToken, fileName) {
    const response = await fetch(`${this.baseApi}/dd-tr-file/${fileName}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }

  async deleteFile(accessToken, fileName) {
    const response = await fetch(`${this.baseApi}/dd-tr/delete-file`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify({ fileName }),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
